import React from "react";
import "./ProgressBar.scss";

interface IBar {
  progress: number;
  done: boolean;
}

export const ProgressBar = ({ progress, done }: IBar): JSX.Element => {
  return (
    <div className="w3-border">
      <div className="w3-grey" style={{ width: progress + "%" }}>
        {progress === 100
          ? done
            ? "Готово"
            : "Загружено. Обработка.."
          : progress + "%"}
      </div>
    </div>
  );
};
